import React, {useState} from "react";
import {Tooltip, Modal, Upload, Button, Space, Table} from "antd";
import {useStore} from "../../../../hooks/useStore";
import {ActionButtonsContainer} from "../actionButtons/ActionButtons.styles";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {DownloadOutlined, UploadOutlined} from "@ant-design/icons";
import {useFetch} from "../../../../hooks/useFetch";

const UploadPoolShiftButton = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const stores = useStore();

    const [excelDataLoading, excelData] = useFetch({
        fetchFn: () => {
            if (!file) return;
            const formData = new FormData();
            formData.append("file", file);
            return stores.poolShiftStore.bookSlotsWithExcel(formData);
        },
        dependencies: [file]
    });
    const result = excelData?.bookSlotsWithExcelResult;

    const handleModalClose = () => {
        setIsModalOpen(false);
        setFile(null);
        setShowDetails(false);
    };

    return (
        <ActionButtonsContainer>
            <Tooltip title={"Vardiya Yükle"}>
                <CustomButton
                    type="primary"
                    onClick={() => setIsModalOpen(true)}
                    style={{width: "100%", marginRight: 0}}
                >
                    Vardiya Yükle
                </CustomButton>
            </Tooltip>

            <Modal
                title="Vardiya Yükleme"
                visible={isModalOpen}
                onOk={handleModalClose}
                onCancel={handleModalClose}
                width={1200}
                style={{
                    top: 20
                }}
            >
                <Space direction="vertical" size="middle" style={{width: "100%"}}>
                    <div>
                        <Button
                            icon={<DownloadOutlined />}
                            onClick={() => {
                                const s3Url =
                                    "https://vigo-be.s3.eu-west-1.amazonaws.com/vardiya-taslak.xlsx";
                                const link = document.createElement("a");
                                link.href = s3Url;
                                link.setAttribute("download", "vardiya-yukleme-sablonu.xlsx");
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }}
                        >
                            Vardiya Yükleme Şablonunu İndir
                        </Button>
                    </div>

                    <Upload
                        accept=".xlsx, .xls"
                        beforeUpload={file => {
                            setFile(file);
                            return false;
                        }}
                    >
                        <Button
                            icon={<UploadOutlined />}
                            loading={excelDataLoading}
                            style={{width: "100%"}}
                        >
                            Excel Dosyası Seç
                        </Button>
                    </Upload>

                    <p style={{color: "#666"}}>
                        Not: Lütfen Excel formatında (.xlsx, .xls) dosya yükleyiniz.
                    </p>
                    <div>
                        <p>{result?.message}</p>
                    </div>
                    {file && result?.errorsData && (
                        <>
                            <Button onClick={() => setShowDetails(!showDetails)}>
                                {showDetails ? "Detayları Gizle" : "Detayları Gör"}
                            </Button>

                            {showDetails && (
                                <Table
                                    dataSource={result?.errorsData}
                                    pagination={{
                                        pageSize: 5,
                                        hideOnSinglePage: true,
                                        position: ["bottomCenter"]
                                    }}
                                >
                                    <Table.Column
                                        title="Havuz İsmi"
                                        dataIndex="poolName"
                                        key="poolName"
                                        render={(text, record) => (
                                            <div>{record?.chunk?.poolName}</div>
                                        )}
                                    />
                                    <Table.Column
                                        title="Tarih"
                                        dataIndex="date"
                                        key="date"
                                        width={160}
                                        render={(text, record) => <div>{record?.chunk?.date}</div>}
                                    />
                                    <Table.Column
                                        title="Kurye TC"
                                        dataIndex="kuryeTckn"
                                        key="kuryeTckn"
                                        render={(text, record) => (
                                            <div>{record?.chunk?.kuryeTckn}</div>
                                        )}
                                    />
                                    <Table.Column
                                        title="Kurye İsim(Excel)"
                                        dataIndex="courierName"
                                        key="courierName"
                                        render={(text, record) => (
                                            <div>{record?.chunk?.courierName}</div>
                                        )}
                                    />
                                    <Table.Column
                                        title="Kurye İsim(Sistem)"
                                        dataIndex="dbCourierName"
                                        key="dbCourierName"
                                        render={(text, record) => (
                                            <div>{record?.chunk?.dbCourierName}</div>
                                        )}
                                    />
                                    <Table.Column
                                        title="Başlangıç Saati"
                                        dataIndex="startHour"
                                        key="startHour"
                                        render={(text, record) => (
                                            <div>{record?.chunk?.startHour}</div>
                                        )}
                                    />
                                    <Table.Column
                                        title="Bitiş Saati"
                                        dataIndex="endHour"
                                        key="endHour"
                                        render={(text, record) => (
                                            <div>{record?.chunk?.endHour}</div>
                                        )}
                                    />
                                    <Table.Column
                                        title="Hata"
                                        dataIndex="error"
                                        key="error"
                                        render={(text, record) => <div>{record?.error}</div>}
                                    />
                                </Table>
                            )}
                        </>
                    )}
                </Space>
            </Modal>
        </ActionButtonsContainer>
    );
};

export default UploadPoolShiftButton;
